export default __webpack_public_path__ + "static/media/Emblem_Platinum.a160bf6a.webp";